import {RelationshipType} from 'graphql-client/__generated/graphqlGlobalTypes';
import {BenchlingIconName} from 'ui-library/icons/BenchlingIcon';

export type DomainGraphScalar =
  | 'String'
  | 'Int'
  | 'Float'
  | 'DecimalValueLegalText'
  | 'Double'
  | 'Boolean'
  | 'Date'
  | 'BenchlingDate'
  | 'DateTime'
  | 'BenchlingDateTime'
  | 'JSON';

export enum SchemaDomainTypeInterface {
  IDnaSequence = 'IDnaSequence',
  IDnaOligo = 'IDnaOligo',
  IRnaSequence = 'IRnaSequence',
  IRnaOligo = 'IRnaOligo',
  IAaSequence = 'IAaSequence',
  IProtein = 'IProtein',
  IMolecule = 'IMolecule',
  IPlate = 'IPlate',
  IMatrixPlate = 'IMatrixPlate',
  IWellPlate = 'IWellPlate',
  IContainer = 'IContainer',
  IBox = 'IBox',
  ILocation = 'ILocation',
  IMixture = 'IMixture',
  ICustomEntity = 'ICustomEntity',
  IEntry = 'IEntry',
  IResult = 'IResult',
  IRun = 'IRun',
}

export interface DomainGraphSchemaData {
  id: string;
  name: string;
  displayName: string;
  fields: Array<DomainGraphSchemaFieldData>;
  domainTypeInterface: string;
}

export interface DomainGraphSchemaFieldData {
  fieldId: string;
  schemaId: string;
  name: string;
  index: number;
  typeName: string;
  iconName: BenchlingIconName;
  isMulti: boolean;
  targetSchemaId?: string; // For link fields only
}

interface SchemasById {
  [schemaId: string]: DomainGraphSchemaData;
}

export interface DomainGraphRelationshipData {
  id: string;
  type: RelationshipType;
  sourceSchemaId: string;
  sourceFieldId: string;
  targetSchemaId: string;
}

export interface RelationshipsForSchema {
  sourceRelationships: Array<DomainGraphRelationshipData>;
  targetRelationships: Array<DomainGraphRelationshipData>;
}

export interface RelationshipsBySchemaId {
  [schemaId: string]: RelationshipsForSchema;
}

export interface DomainGraphModelData {
  schemas: SchemasById;
  relationships: RelationshipsBySchemaId;
}
